import React from 'react';
/**
 * PopupSplit
 * Horizontal rule divider between popup sections.
 * Never place before the first section.
 * @version 1.0.0
 * @since 2026-03-27
 */
export function PopupSplit() {
    return React.createElement("hr", { className: "popup__split" });
}
PopupSplit.displayName = 'PopupSplit';
